export default __webpack_public_path__ + "static/media/incubator-bg.974a9546.jpg";